import React, { useState } from "react";
import { Avatar } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import CustomTable from "../components/Table";

const Resignation = () => {
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");

  const data = [
    {
      key: "1",
      name: "Antony",
      department: "Finance",
      reason: "Career Change",
      noticeDate: "14 Jan 2024",
      resignDate: "14 Mar 2024",
    },
    {
      key: "2",
      name: "Antony",
      department: "Finance",
      reason: "Relocations",
      noticeDate: "14 Jan 2024",
      resignDate: "14 Mar 2024",
    },
    {
      key: "3",
      name: "Antony",
      department: "Finance",
      reason: "Health Reasons",
      noticeDate: "14 Jan 2024",
      resignDate: "14 Mar 2024",
    },
    {
      key: "4",
      name: "Antony",
      department: "Finance",
      reason: "Personal Development",
      noticeDate: "14 Jan 2024",
      resignDate: "14 Mar 2024",
    },
  ];

  const filteredData = data.filter((item) =>
    item.name.toLowerCase().includes(searchText.toLowerCase())
  );

  const columns = [
    {
      title: "",
      render: () => <input type="checkbox" />,
      width: 50,
    },
    {
      title: "Resigning Employee",
      dataIndex: "name",
      render: (text) => (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Avatar src="https://i.pravatar.cc/40" />
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "Department",
      dataIndex: "department",
    },
    {
      title: "Reason",
      dataIndex: "reason",
    },
    {
      title: "Notice Date",
      dataIndex: "noticeDate",
    },
    {
      title: "Resignation Date",
      dataIndex: "resignDate",
    },
    {
      title: "Action",
      render: () => (
        <div className="action-icons">
          <EditOutlined />
          <DeleteOutlined />
        </div>
      ),
    },
  ];

  return (
    <CustomTable
      title="Resignation List"
      columns={columns}
      data={filteredData}
      pageSize={pageSize}
      setPageSize={setPageSize}
      onSearch={setSearchText}
    />
  );
};

export default Resignation;